<template>
    <form @submit.prevent="submitPayment">
        <div class="row justify-content-center align-items-center ">
            <h3 class="text-uppercase pb-3">{{$ml.get('billing')}}</h3>
        </div>
        <div class="row justify-content-center align-items-center ">
            <div class="col-5 pb-3">
                <label class="mr-2 qf-radio">
                    <input type="radio" name="type" value="person" v-model="formData.type">
                    <span class="qf-radio-btn"></span>
                    <span>{{$ml.get('Person')}}</span>
                </label>
                <label class="ml-2 qf-radio">
                    <input type="radio" name="type" value="company" v-model="formData.type">
                    <span class="qf-radio-btn"></span>
                    <span>{{$ml.get('Company')}}</span>
                </label>
            </div>
        </div>
        <div class="row justify-content-center align-items-center ">
            <div class="col-5">
                <div class="row">
                    <div class="col-6 form-group">
                        <label class="ml-2 text-uppercase mb-0" for="first_name">{{$ml.get('first_name')}}</label>
                        <input type="text" class="form-control" id="first_name" name="first_name"
                               :placeholder="$ml.get('first_name')" v-model="formData.first_name"
                               v-validate="'required'" :class="{'is-invalid': errors.has('first_name')}">
                        <small class="form-text text-danger pl-3"
                               v-if="errorMessages.first_name.length">
                            {{errorMessages.first_name}}
                        </small>
                    </div>
                    <div class="col-6 form-group">
                        <label class="ml-2 text-uppercase mb-0" for="last_name">{{$ml.get('last_name')}}</label>
                        <input type="text" class="form-control" id="last_name" name="last_name"
                               :placeholder="$ml.get('last_name')" v-model="formData.last_name"
                               v-validate="'required'" :class="{'is-invalid': errors.has('last_name')}">
                        <small class="form-text text-danger pl-3"
                               v-if="errorMessages.last_name.length">
                            {{errorMessages.last_name}}
                        </small>
                    </div>
                </div>
            </div>
        </div>
        <div class="row justify-content-center align-items-center">
            <div class="col-5 form-group">
                <label class="ml-2 text-uppercase mb-0" for="address">{{$ml.get('address')}}</label>
                <input type="text" class="form-control" id="address" name="address"
                       :placeholder="$ml.get('address')" v-model="formData.address"
                       v-validate="'required'" :class="{'is-invalid': errors.has('address')}">
                <small class="form-text text-danger pl-3"
                       v-if="errorMessages.address.length">
                    {{errorMessages.address}}
                </small>
            </div>
        </div>
        <div class="row justify-content-center align-items-center">
            <div class="col-5 form-group">
                <label class="ml-2 text-uppercase mb-0" for="city">{{$ml.get('city')}}</label>
                <input type="text" class="form-control" id="city" name="city"
                       :placeholder="$ml.get('city')" v-model="formData.city"
                       v-validate="'required'" :class="{'is-invalid': errors.has('city')}">
                <small class="form-text text-danger pl-3"
                       v-if="errorMessages.city.length">
                    {{errorMessages.city}}
                </small>
            </div>
        </div>
        <div class="row justify-content-center align-items-center">
            <div class="col-5 form-group">
                <label class="ml-2 text-uppercase mb-0" for="country">{{$ml.get('country')}}</label>
                <select class="form-control" id="country" name="country"
                        :placeholder="$ml.get('country')" v-model="formData.country"
                        v-validate="'required|excluded:0'" :class="{'is-invalid': errors.has('country')}">
                    <option disabled value="0">{{$ml.get('select_a_country')}}</option>
                    <option v-for="(value, index) of countriesList" :value="value.code" :key="index">{{value.name}}
                    </option>
                </select>
                <small class="form-text text-danger pl-3"
                       v-if="errorMessages.country.length">
                    {{errorMessages.country}}
                </small>
            </div>
        </div>
        <div class="row justify-content-center align-items-center" v-if="formData.type === 'company'">
            <div class="col-5 form-group">
                <label class="ml-2 text-uppercase mb-0" for="company">{{$ml.get('company')}}</label>
                <input type="text" class="form-control" id="company" name="company"
                       :placeholder="$ml.get('company')" v-model="formData.company">
                <small class="form-text text-danger pl-3"
                       v-if="errorMessages.company_name.length">
                    {{errorMessages.company_name}}
                </small>
            </div>
        </div>
        <div class="row justify-content-center align-items-center" v-if="formData.type === 'company'">
            <div class="col-5 form-group">
                <label class="ml-2 text-uppercase mb-0" for="vat">{{$ml.get('vat')}}</label>
                <input type="text" class="form-control" id="vat" name="vat"
                       :placeholder="$ml.get('vat')" v-model="formData.vat">
                <small class="form-text text-danger pl-3"
                       v-if="errorMessages.vat.length">
                    {{errorMessages.vat}}
                </small>
            </div>
        </div>

        <div class="row justify-content-center align-items-center pt-5">
            <h3 class="text-uppercase pb-3">{{$ml.get('payment_options')}}</h3>
        </div>

        <div class="row justify-content-center align-items-center">
            <div class="col-5 form-group">
                <label class="w-100 mb-0">
                    <div>{{$ml.get('card_number')}}</div>
                    <div ref="cardNumber"></div>
                </label>
            </div>
        </div>

        <div class="row justify-content-center align-items-center">
            <div class="col-5">
                <div class="row justify-content-start align-items-center">
                    <div class="col-8 form-group">
                        <label class="w-100 mb-0">
                            <div>{{$ml.get('Expiration_Date')}}</div>
                            <div ref="cardExpiry"></div>
                        </label>
                    </div>
                    <div class="col-4 form-group">
                        <label class="w-100 mb-0">
                            <div>{{$ml.get('cvc')}}
                            </div>
                            <div ref="cardCvc"></div>
                        </label>
                    </div>
                </div>
            </div>
        </div>

        <div class="row justify-content-center align-items-center">
            <div class="col-5 form-group">
                <label class="ml-2 text-uppercase mb-0" for="card_holder">{{$ml.get('card_holder')}}</label>
                <input type="text" class="form-control" id="card_holder" name="card_holder"
                       :placeholder="$ml.get('card_holder')" v-model="formData.card_holder"
                       v-validate="'required'" :class="{'is-invalid': errors.has('card_holder')}">
            </div>
        </div>
        <div class="row justify-content-center align-items-center pt-4">
            <div class="col-5 pt-4 text-center">
                <font-awesome-icon icon="spinner" size="2x" class="fa-spin" v-if="loading"/>
                <button type="submit" class="btn btn-lg btn-warning form-control text-uppercase" v-else>
                    {{$ml.get('continue')}}
                </button>
            </div>
        </div>
        <div class="row justify-content-center align-items-center"
             v-if="errorMessages.generalError.length">
            <div class="col-5 form-group">
                <small class="form-text text-danger">
                    {{$ml.get('general_error_msg')}}
                </small>
            </div>
        </div>

    </form>
</template>

<script>
    import {countries} from '../../helpers/countries'

    let stripe = Stripe(process.env.VUE_APP_STRIPE_KEY),
        elements = stripe.elements(),
        cardNumber = undefined,
        cardExpiry = undefined,
        cardCvc = undefined;

    export default {
        name: "billing",
        data() {
            return {
                formData: {
                    type: 'person',
                    first_name: '',
                    last_name: '',
                    address: '',
                    city: '',
                    country: 0,
                    company: '',
                    vat: '',
                    card_holder: ''
                },
                errorMessages: {
                    address: '',
                    city: '',
                    country: '',
                    first_name: '',
                    last_name: '',
                    company_name: '',
                    vat: '',
                    generalError: ''
                },
                countriesList: countries,
                loading: false
            }
        },
        mounted() {
            if (!this.$store.getters.hasData('createdUser')) {
                this.$router.push({name: 'home'});
            }
            this.formData.first_name = this.$store.state.createdUser.first_name;
            this.formData.last_name = this.$store.state.createdUser.last_name;
            this.formData.card_holder = `${this.$store.state.createdUser.first_name} ${this.$store.state.createdUser.last_name}`;
            const style = {
                base: {
                    fontSize: '16px',
                    color: '#002e42',
                    '::placeholder': {
                        color: '#B7B7B7'
                    }
                },
                invalid: {
                    color: '#dc3545',
                    borderColor: '#dc3545'
                }
            };
            const classes = {
                base: 'form-control qf-payment-input',
                focus: 'qf-payment-input-focus',
                invalid: 'is-invalid'
            };

            cardNumber = elements.create('cardNumber', {
                classes: classes, style: style
            });
            cardNumber.mount(this.$refs.cardNumber);
            cardExpiry = elements.create('cardExpiry', {
                classes: classes, style: style
            });
            cardExpiry.mount(this.$refs.cardExpiry);
            cardCvc = elements.create('cardCvc', {
                classes: classes, style: style
            });
            cardCvc.mount(this.$refs.cardCvc);
        },
        methods: {
            submitPayment() {
                if (!this.loading) {
                    this.errorMessages = {
                        address: '',
                        city: '',
                        country: '',
                        first_name: '',
                        last_name: '',
                        company_name: '',
                        vat: '',
                        generalError: ''
                    };
                    this.$validator.validateAll().then((result) => {
                        this.loading = true;
                        if (result || 1) {
                            let tokenData = {
                                name: this.formData.cardHolder,
                                address_line1: this.formData.cardAddress,
                                address_country: this.formData.cardCountry,
                                address_zip: this.formData.cardZip,
                            };
                            this.loading = true;
                            stripe.createToken(cardNumber, tokenData).then((result) => {
                                if (result.error) {
                                    this.loading = false;
                                } else {
                                    let data = {
                                        "stripeToken": result.token.id,
                                    };
                                }
                            });

                            let data = {
                                plan_id: this.$store.state.plans[this.$store.state.selectedPlanIndex].id,
                                billing_type: this.formData.type,
                                company_name: this.formData.company,
                                vat: this.formData.vat,
                                address: this.formData.address,
                                city: this.formData.city,
                                country: this.formData.country
                            };

                            this.$store.dispatch('checkOut', {
                                id: this.$store.state.createdUser.id,
                                data: data
                            }).then(response => {
                                this.loading = false;
                                this.$router.push({name: 'Success'});
                            }).catch(error => {
                                if (error.status === 400) {
                                    error.data.forEach(obj => {
                                        this.errorMessages[obj.property_path] = obj.message;
                                    });
                                } else {
                                    this.errorMessages.generalError = 'error';
                                }
                                this.loading = false;
                            });

                        } else {

                        }
                    });
                }
            }
        },
        beforeDestroy() {
            cardNumber.destroy();
            cardExpiry.destroy();
            cardCvc.destroy();
        }
    }
</script>

<style scoped>

    .qf-payment-input {
        color: #002e42;
        height: 38px;
        padding-top: 8px;
        border-color: #6c757d !important;
    }

    .qf-payment-input-focus {
        outline: 0;
        -webkit-box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, .25);
        box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, .25);
    }

    .qf-payment-input.is-invalid {
        color: #dc3545;
        border-color: #dc3545 !important;
    }

    .qf-payment-input.is-invalid.qf-payment-input-focus {
        -webkit-box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, .25);
        box-shadow: 0 0 0 0.2rem rgba(220, 53, 69, .25);
    }

</style>